export function updateEditorialRejectionReasonForFilter({
  entitySchema, enableEditorialRejectionFilter, i18n,
}) {
  // update editorial rejection reason filter property
  const editorialRejectionFlagId = entitySchema.properties.EditorialRejectionFlagId;
  const editorialRejectionDate = entitySchema.properties.EditorialRejectionDate;

  if (editorialRejectionFlagId) {
    editorialRejectionFlagId.filterable = enableEditorialRejectionFilter;
    editorialRejectionFlagId.title = i18n && i18n.getString('Schema_Ad_Property_EditorialRejectionFlagId');
  }
  if (editorialRejectionDate) {
    editorialRejectionDate.filterable = enableEditorialRejectionFilter;
    editorialRejectionDate.title = i18n && i18n.getString('Schema_Ad_Property_EditorialRejectionDate');
  }
}
